import { createIcon } from "@chakra-ui/react";

export const NavItemChevronRight = createIcon({
  displayName: "NavItemChevronRight",
  viewBox: "7 4 10 16",
  defaultProps: {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
  },
  path: (
    <polyline points="9 18 15 12 9 6" />
  ),
});
